// Default strings for the "LUMEN" checkout template. Merchant overrides come
// from store.checkout_ui (help_text, guarantee_text, pay_button_text, trust_items…).
// These are the fallbacks per language.

const LUMEN = {
  fr: {
    secure_order: 'Commande protégée et sécurisée',
    help: "Besoin d'aide ? Contactez-nous",
    step_data: 'Infos',
    step_payment: 'Paiement',
    step_confirm: 'Confirmation',
    express: 'Paiement express',
    or_card: 'Ou payer par carte',
    sec_personal: 'Informations personnelles',
    sec_address: 'Adresse de livraison',
    sec_payment: 'Mode de paiement',
    order_summary: 'Récapitulatif de la commande',
    tax_included: 'TVA incluse',
    guarantee: 'Satisfait ou remboursé sous 30 jours',
    complete_order: 'Finaliser la commande',
    terms_pre: 'En finalisant la commande, vous acceptez les',
    terms_tc: 'Conditions générales',
    terms_and: 'et la',
    terms_pp: 'Politique de confidentialité',
    trust: [
      { icon: 'lock', title: 'Paiement sécurisé', subtitle: 'Vos données sont protégées par un chiffrement SSL 256 bits.' },
      { icon: 'truck', title: 'Livraison rapide', subtitle: '2-4 jours ouvrés avec un transporteur express.' },
      { icon: 'refresh', title: 'Retour facile', subtitle: 'Retour gratuit sous 30 jours après réception.' },
      { icon: 'headset', title: 'Service client', subtitle: 'Nous sommes disponibles 7 jours sur 7.' },
    ],
    footer: [
      { icon: 'truck', title: 'Livraison gratuite', subtitle: 'Pour toute commande' },
      { icon: 'truck', title: 'Livraison 2-4 jours', subtitle: 'Transporteur express' },
      { icon: 'refresh', title: 'Retour gratuit 30 jours', subtitle: 'Satisfait ou remboursé' },
      { icon: 'lock', title: 'Paiements sécurisés', subtitle: 'Carte, PayPal, Apple Pay' },
    ],
  },
  en: {
    secure_order: 'Protected and secure order',
    help: 'Need help? Contact us',
    step_data: 'Details', step_payment: 'Payment', step_confirm: 'Confirmation',
    express: 'Express checkout', or_card: 'Or pay by card',
    sec_personal: 'Personal details', sec_address: 'Shipping address', sec_payment: 'Payment method',
    order_summary: 'Order summary', tax_included: 'Tax included',
    guarantee: '30-day money-back guarantee', complete_order: 'Complete order',
    terms_pre: 'By completing the order, you accept the', terms_tc: 'Terms & Conditions',
    terms_and: 'and the', terms_pp: 'Privacy Policy',
    trust: [
      { icon: 'lock', title: 'Secure payment', subtitle: 'Your data is protected by 256-bit SSL encryption.' },
      { icon: 'truck', title: 'Fast delivery', subtitle: '2-4 business days with express courier.' },
      { icon: 'refresh', title: 'Easy returns', subtitle: 'Free return within 30 days of delivery.' },
      { icon: 'headset', title: 'Customer support', subtitle: 'We are available 7 days a week.' },
    ],
    footer: [
      { icon: 'truck', title: 'Free shipping', subtitle: 'On every order' },
      { icon: 'truck', title: 'Delivery 2-4 days', subtitle: 'Express courier' },
      { icon: 'refresh', title: 'Free 30-day return', subtitle: 'Satisfied or refunded' },
      { icon: 'lock', title: 'Secure payments', subtitle: 'Card, PayPal, Apple Pay' },
    ],
  },
  es: {
    secure_order: 'Pedido protegido y seguro',
    help: '¿Necesitas ayuda? Contáctanos',
    step_data: 'Datos', step_payment: 'Pago', step_confirm: 'Confirmación',
    express: 'Pago rápido', or_card: 'O paga con tarjeta',
    sec_personal: 'Datos personales', sec_address: 'Dirección de envío', sec_payment: 'Método de pago',
    order_summary: 'Resumen del pedido', tax_included: 'IVA incluido',
    guarantee: 'Satisfecho o reembolsado en 30 días', complete_order: 'Finalizar el pedido',
    terms_pre: 'Al finalizar el pedido, aceptas los', terms_tc: 'Términos y condiciones',
    terms_and: 'y la', terms_pp: 'Política de privacidad',
    trust: [
      { icon: 'lock', title: 'Pago seguro', subtitle: 'Tus datos están protegidos con cifrado SSL de 256 bits.' },
      { icon: 'truck', title: 'Entrega rápida', subtitle: '2-4 días laborables con mensajería exprés.' },
      { icon: 'refresh', title: 'Devolución fácil', subtitle: 'Devolución gratuita en 30 días tras la entrega.' },
      { icon: 'headset', title: 'Atención al cliente', subtitle: 'Estamos disponibles los 7 días de la semana.' },
    ],
    footer: [
      { icon: 'truck', title: 'Envío gratis', subtitle: 'En todos los pedidos' },
      { icon: 'truck', title: 'Entrega 2-4 días', subtitle: 'Mensajería exprés' },
      { icon: 'refresh', title: 'Devolución gratis 30 días', subtitle: 'Satisfecho o reembolsado' },
      { icon: 'lock', title: 'Pagos seguros', subtitle: 'Tarjeta, PayPal, Apple Pay' },
    ],
  },
  nl: {
    secure_order: 'Beschermde en veilige bestelling',
    help: 'Hulp nodig? Neem contact op',
    step_data: 'Gegevens', step_payment: 'Betaling', step_confirm: 'Bevestiging',
    express: 'Snel afrekenen', or_card: 'Of betaal met kaart',
    sec_personal: 'Persoonlijke gegevens', sec_address: 'Verzendadres', sec_payment: 'Betaalmethode',
    order_summary: 'Besteloverzicht', tax_included: 'Incl. btw',
    guarantee: '30 dagen niet-goed-geld-terug', complete_order: 'Bestelling afronden',
    terms_pre: 'Door de bestelling af te ronden, accepteer je de', terms_tc: 'Algemene voorwaarden',
    terms_and: 'en het', terms_pp: 'Privacybeleid',
    trust: [
      { icon: 'lock', title: 'Veilig betalen', subtitle: 'Je gegevens worden beschermd met 256-bit SSL-versleuteling.' },
      { icon: 'truck', title: 'Snelle levering', subtitle: '2-4 werkdagen met expreskoerier.' },
      { icon: 'refresh', title: 'Eenvoudig retourneren', subtitle: 'Gratis retour binnen 30 dagen na levering.' },
      { icon: 'headset', title: 'Klantenservice', subtitle: 'We zijn 7 dagen per week beschikbaar.' },
    ],
    footer: [
      { icon: 'truck', title: 'Gratis verzending', subtitle: 'Op elke bestelling' },
      { icon: 'truck', title: 'Levering 2-4 dagen', subtitle: 'Expreskoerier' },
      { icon: 'refresh', title: 'Gratis retour 30 dagen', subtitle: 'Niet goed, geld terug' },
      { icon: 'lock', title: 'Veilige betalingen', subtitle: 'Kaart, PayPal, Apple Pay' },
    ],
  },
  it: {
    secure_order: 'Ordine protetto e sicuro',
    help: 'Hai bisogno di aiuto? Contattaci',
    step_data: 'Dati', step_payment: 'Pagamento', step_confirm: 'Conferma',
    express: 'Checkout veloce', or_card: 'Oppure paga con carta',
    sec_personal: 'Dati personali', sec_address: 'Indirizzo di spedizione', sec_payment: 'Metodo di pagamento',
    order_summary: 'Riepilogo ordine', tax_included: 'IVA inclusa',
    guarantee: 'Garanzia soddisfatti o rimborsati 30 giorni', complete_order: "Completa l'ordine",
    terms_pre: "Completando l'ordine accetti i", terms_tc: 'Termini e Condizioni',
    terms_and: 'e la', terms_pp: 'Privacy Policy',
    trust: [
      { icon: 'lock', title: 'Pagamento sicuro', subtitle: 'I tuoi dati sono protetti con crittografia SSL a 256 bit.' },
      { icon: 'truck', title: 'Consegna rapida', subtitle: '2-4 giorni lavorativi con corriere espresso.' },
      { icon: 'refresh', title: 'Reso facile', subtitle: 'Reso gratuito entro 30 giorni dalla consegna.' },
      { icon: 'headset', title: 'Assistenza clienti', subtitle: 'Siamo disponibili 7 giorni su 7.' },
    ],
    footer: [
      { icon: 'truck', title: 'Spedizione gratuita', subtitle: 'Per ogni ordine' },
      { icon: 'truck', title: 'Consegna 2-4 giorni', subtitle: 'Con corriere espresso' },
      { icon: 'refresh', title: 'Reso gratuito 30 giorni', subtitle: 'Soddisfatti o rimborsati' },
      { icon: 'lock', title: 'Pagamenti sicuri', subtitle: 'Carta, PayPal, Apple Pay' },
    ],
  },
  de: {
    secure_order: 'Geschützte und sichere Bestellung',
    help: 'Brauchen Sie Hilfe? Kontaktieren Sie uns',
    step_data: 'Angaben', step_payment: 'Zahlung', step_confirm: 'Bestätigung',
    express: 'Express-Zahlung', or_card: 'Oder mit Karte bezahlen',
    sec_personal: 'Persönliche Angaben', sec_address: 'Lieferadresse', sec_payment: 'Zahlungsmethode',
    order_summary: 'Bestellübersicht', tax_included: 'inkl. MwSt.',
    guarantee: '30 Tage Geld-zurück-Garantie', complete_order: 'Bestellung abschließen',
    terms_pre: 'Mit dem Abschluss der Bestellung akzeptieren Sie die', terms_tc: 'AGB',
    terms_and: 'und die', terms_pp: 'Datenschutzerklärung',
    trust: [
      { icon: 'lock', title: 'Sichere Zahlung', subtitle: 'Ihre Daten sind mit 256-Bit-SSL-Verschlüsselung geschützt.' },
      { icon: 'truck', title: 'Schnelle Lieferung', subtitle: '2-4 Werktage mit Express-Kurier.' },
      { icon: 'refresh', title: 'Einfache Rückgabe', subtitle: 'Kostenlose Rückgabe innerhalb von 30 Tagen nach Erhalt.' },
      { icon: 'headset', title: 'Kundenservice', subtitle: 'Wir sind 7 Tage die Woche erreichbar.' },
    ],
    footer: [
      { icon: 'truck', title: 'Kostenloser Versand', subtitle: 'Für jede Bestellung' },
      { icon: 'truck', title: 'Lieferung 2-4 Tage', subtitle: 'Express-Kurier' },
      { icon: 'refresh', title: 'Kostenlose Rückgabe 30 Tage', subtitle: 'Zufrieden oder Geld zurück' },
      { icon: 'lock', title: 'Sichere Zahlungen', subtitle: 'Karte, PayPal, Apple Pay' },
    ],
  },
};

const DELIVERY_ESTIMATE = {
  fr: 'Livraison estimée : 2-4 jours ouvrés',
  en: 'Estimated delivery: 2-4 business days',
  es: 'Entrega estimada: 2-4 días laborables',
  nl: 'Geschatte levering: 2-4 werkdagen',
  it: 'Consegna stimata: 2-4 giorni lavorativi',
  de: 'Voraussichtliche Lieferung: 2-4 Werktage',
};

const TP_EXCELLENT = { fr: 'Excellent', en: 'Excellent', es: 'Excelente', nl: 'Uitstekend', it: 'Eccellente', de: 'Hervorragend' };

export const getLumenT = (lang) => {
  const base = LUMEN[lang] || LUMEN.fr;
  return {
    ...base,
    delivery_estimate: base.delivery_estimate || DELIVERY_ESTIMATE[lang] || DELIVERY_ESTIMATE.fr,
    tp_excellent: TP_EXCELLENT[lang] || TP_EXCELLENT.fr,
  };
};

// Lucide icon keys available for trust/footer items (used by admin + checkout).
export const LUMEN_ICONS = ['shield', 'lock', 'truck', 'refresh', 'headset', 'check', 'star', 'gift', 'clock'];
